import React, { FC } from "react";
import { Space, Typography } from "antd";
import { useTheme } from "../../../../Styles/ThemeHook";
import { BedIcon2 } from "shared-components/Components/CustomIcons/BedIcon2/web";
import { BedIcon } from "shared-components/Components/CustomIcons/BedIcon/web";

interface RoomsTagProps {
	rooms: number;
	icon?: boolean;
	prefix?: boolean;
	isEspecial?: Boolean;
}

export const RoomsTag: FC<RoomsTagProps> = ({
	rooms,
	icon = false,
	prefix = false,
	isEspecial,
}) => {
	const { theme } = useTheme();

	return (
		<Space size={theme.spacing.smSpacing}>
			{isEspecial ? (
				<>
					{icon && <BedIcon2 className="icon" />}
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Typography.Text className="name" ellipsis>
							Ambiente{rooms!=1 ? 's':''}
						</Typography.Text>
						<Typography.Text className="count" ellipsis>
							{prefix ? `+${rooms}` : rooms}
						</Typography.Text>
					</div>
				</>
			) : (
				<>
					{icon && <BedIcon style={{ color: theme.colors.textSecondaryColor }} />}
					<Typography.Text ellipsis>
						{ prefix ? "+" : ""}{rooms} Ambiente{rooms!=1 ? 's':''}
					</Typography.Text>
				</>
			)}
		</Space>
	);
};
